import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'María G.',
  location: 'Buenos Aires',
  quote: 'Finalmente encontré una formación que respeta mi tiempo y mi inteligencia. El Nivel I me dio la base que necesitaba para empezar a practicar con confianza.',
  initials: 'MG'
}, {
  name: 'Carolina R.',
  location: 'Ciudad de México',
  quote: 'El Combo 2 fue la mejor inversión que hice en mi desarrollo profesional. Los manuales son completos, claros y muy bien estructurados.',
  initials: 'CR'
}, {
  name: 'Valentina M.',
  location: 'Bogotá',
  quote: 'Lo que más valoro es la progresión lógica entre niveles. Se nota que fue diseñado por alguien que realmente entiende la enseñanza del Reiki.',
  initials: 'VM'
}];
export function TestimonialsSection() {
  return <section className="py-20 bg-[#1e1254]" data-id="element-290">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-291">
        <div className="text-center mb-16" data-id="element-292">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-293">
            Lo que Dicen Nuestros Estudiantes
          </h2>
          <div className="h-1 w-20 bg-[#d4af37] mx-auto rounded-full" data-id="element-294" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-295">
          {testimonials.map((t, i) => <motion.div key={i} className="bg-[#0f0a2e] p-8 rounded-lg border border-purple-900/50 relative" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} data-id="element-296">
              <div className="flex gap-1 mb-4" data-id="element-297">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-[#d4af37] fill-current" data-id="element-298" />)}
              </div>
              <p className="text-purple-100 italic mb-6 leading-relaxed" data-id="element-299">
                "{t.quote}"
              </p>
              <div className="flex items-center" data-id="element-300">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-500 to-indigo-600 flex items-center justify-center text-white font-bold text-sm mr-3" data-id="element-301">
                  {t.initials}
                </div>
                <div data-id="element-302">
                  <p className="text-white font-semibold text-sm" data-id="element-303">{t.name}</p>
                  <p className="text-purple-400 text-xs" data-id="element-304">{t.location}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}